import {DashboardType} from "../../../model/dashboard/types";
import {DashboardConfig} from "../../../model/dashboard/dashboard-config";
import {WidgetConfig} from "../../../model/widget/widget-config";
import {ConditionsLogicalOperator} from "../../../../../model2/conditions/collection";
import {CardViewLayout} from "../../../../../gd-ui/card-view-selector/card-view-selector";
import {WidgetType} from "../../../model/widget/widget-type";
import {CounterType} from "../../../widgets/constants/types";

export function projectAgileConfig() {

    const widgets : WidgetConfig[] = [
        // {
        //     // "cardLayout": "none",
        //     "title": "High priority tasks",
        //     "color": 6,
        //     "type": WidgetType.TASKS_SUMMARY,
        //     "settings": {
        //         "includeSubFolders": true,
        //         "showPercents": false,
        //         "counterType": "tasks-total",
        //         "showClosedTasks": false,
        //         "projectIds": [
        //             "F9BUGt"
        //         ],
        //         "groupBy": "priority"
        //     },
        //     "gridPosition": {
        //         "y": 7,
        //         "h": 2,
        //         "w": 12,
        //         "x": 0
        //     },
        //     "conditions": {
        //         "conditions": [
        //             {
        //                 "type": "includes",
        //                 "id": "ishd",
        //                 "value": [
        //                     100,
        //                     8,
        //                     10
        //                 ],
        //                 "systemFieldId": "task.priority"
        //             }
        //         ],
        //         "logicalOperator":  ConditionsLogicalOperator.AND
        //     },
        //     "id": "w02n"
        // },
        {
            // "cardLayout": "none",
            "title": "Estimated total",
            "color": 6,
            "type": WidgetType.COUNTER,
            "settings": {
                "projectIds": [
                    "F9BUGt"
                ],
                "label": "Hours",
                "includeSubFolders": true,
                "counterType": "tasks-estimates"
            },
            "gridPosition": {
                "y": 1,
                "h": 1,
                "w": 2,
                "x": 0
            },
            // "conditions": null,
            "id": "mwar"
        },
        {
            // "cardLayout": "none",
            "title": "Estimated left",
            "color": 6,
            "type": WidgetType.COUNTER,
            "settings": {
                "projectIds": [
                    "F9BUGt"
                ],
                "label": "Hours",
                "includeSubFolders": true,
                "counterType": "tasks-estimates"
            },
            "gridPosition": {
                "y": 1,
                "h": 1,
                "w": 2,
                "x": 2
            },
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "cond1",
                        "value": [
                            1,
                            2,
                            3,
                            4
                        ],
                        "systemFieldId": "task.systemStatus"
                    }
                ],
                "logicalOperator":  ConditionsLogicalOperator.AND
            },
            "id": "sj69"
        },
        {
            // "cardLayout": CardViewLayout.COLOR_CODING_NONE,
            "title": "Tasks by AR",
            "color": 6,
            "type": WidgetType.TASKS_SUMMARY,
            "settings": {
                "includeSubFolders": true,
                "showPercents": false,
                "counterType": "tasks-total",
                "showClosedTasks": false,
                "projectIds": [
                    "F9BUGt"
                ],
                "groupBy": "actionRequiredUserId"
            },
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 4
            },
            // "conditions": null,
            "id": "t2bz"
        },
        {
            // "cardLayout": "none",
            "title": "Velocity by time",
            "color": 6,
            "type": WidgetType.VELOCITY,
            "settings": {
                "reportDate": {
                    "lastDays": 30
                },
                "projectIds": [
                    "F9BUGt"
                ],
                "showAverage": true,
                "tickType": "day",
                "counterType": CounterType.TASKS_TOTAL
            },
            "gridPosition": {
                "y": 0,
                "h": 2,
                "w": 4,
                "x": 8
            },
            // "conditions": null,
            "id": "ssmg"
        },
        {
            // "cardLayout": "none",
            "title": "Burndown by tasks",
            "color": 6,
            "type": WidgetType.BURNDOWN,
            "settings": {
                "reportDate": {
                    "lastDays": 30
                },
                "projectIds": [
                    "F9BUGt"
                ],
                "counterType": "tasks-total"
            },
            "gridPosition": {
                "y": 0,
                "h": 2,
                "w": 4,
                "x": 4
            },
            // "conditions": null,
            "id": "abxc"
        },
        {
            // "cardLayout": "none",
            "title": "Reports by user(s)",
            "color": 6,
            "type": WidgetType.TIME_REPORT,
            "settings": {
                "includeSubFolders": true,
                "userIds": [
                    "fJiCNS"
                ],
                "projectIds": [
                    "F9BUGt"
                ],
                "type": "by-task",
                "groupBy": "userId",
                "daterange": {
                    "start": -30,
                    "end": 0
                }
            },
            "gridPosition": {
                "y": 4,
                "h": 3,
                "w": 12,
                "x": 0
            },
            // "conditions": null,
            "id": "cvor"
        },
        {
            // "cardLayout": "none",
            "title": "Tasks by status",
            "color": 6,
            "type": WidgetType.TASK_CHART,
            "settings": {
                "showLegend": false,
                "includeSubFolders": true,
                "includeSubtasks": true,
                "graphType": "pie",
                "counterType": "tasks-total",
                "showClosedTasks": true,
                "projectIds": [
                    "F9BUGt"
                ],
                "groupBy": "statusId"
            },
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 8
            },
            // "conditions": null,
            "id": "qtz6"
        },
        {
            // "cardLayout": "none",
            "title": "Sprint ends in",
            "color": 6,
            "type": WidgetType.COUNTDOWN,
            "settings": {
                "targetMoment": moment().add(7,'days').minutes(0)
            },
            "gridPosition": {
                "y": 0,
                "h": 1,
                "w": 4,
                "x": 0
            },
            // "conditions": null,
            "id": "c3kl"
        },
        {
            "cardLayout": CardViewLayout.COLOR_CODING_BORDER_LEFT,
            "title": "Blockers",
            "color": 16,
            "type": WidgetType.TASK_LIST,
            "settings": {
                "projectIds": [
                    "F9BUGt"
                ],
                "includeSubFolders": true,
                "displayPropertyFieldId": "projectId",
                "showClosedTasks": false,
                "includeSubtasks": true
            },
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 4,
                "x": 0
            },
            "conditions": {
                "conditions": [
                    {
                        "type": "includes",
                        "id": "cond1",
                        "value": [
                            9,
                            7,
                            50
                        ],
                        "systemFieldId": "task.priority"
                    }
                ],
                "logicalOperator": ConditionsLogicalOperator.AND
            },
            "id": "82lw"
        }
    ]

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.PROJECT,
        "widgets"   : widgets
    }

    // dashboardConfig.widgets = dashboardConfig.widgets.concat(createWidgets(userId, widgetIds) as any[])

    return dashboardConfig
}





